import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, getDocs, deleteDoc, doc } from 'firebase/firestore';

export const SeedDataPage = () => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    // Doctor data with LOCAL image paths from public directory
    const doctorsToSeed = [
        {
            name: "Dr. Ajinkya Patil",
            speciality: "Advanced Dental Care",
            qualification: "BDS",
            image: "/images/doctors/doctor_photo.jpg",
            order: Date.now(),
        }
        // Add more doctors here with their local image paths
    ];

    const seedDoctors = async () => {
        setLoading(true);
        setMessage('');

        try {
            // Optional: Clear existing doctors
            const shouldClear = window.confirm("Clear existing doctors first?");
            if (shouldClear) {
                const existingDoctors = await getDocs(collection(db, 'doctors'));
                for (const docSnapshot of existingDoctors.docs) {
                    await deleteDoc(doc(db, 'doctors', docSnapshot.id));
                }
                setMessage('Cleared existing doctors. ');
            }

            // Add new doctors
            for (const doctor of doctorsToSeed) {
                await addDoc(collection(db, 'doctors'), doctor);
            }

            setMessage(prev => prev + `✅ Successfully added ${doctorsToSeed.length} doctor(s)!`);
            alert("Doctors seeded! Go to homepage to see them.");

        } catch (error) {
            setMessage(`❌ Error: ${error.message}`);
            console.error(error);
        }

        setLoading(false);
    };

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
                <h1 className="text-2xl font-bold mb-4 text-gray-800">Seed Firestore Data</h1>
                <p className="text-gray-600 mb-6">
                    This will add doctors to Firestore using local image paths from <code className="bg-gray-100 px-2 py-1 rounded">public/images/doctors/</code>
                </p>

                <div className="bg-blue-50 border border-blue-200 rounded p-4 mb-6">
                    <h3 className="font-bold text-blue-900 mb-2">Doctors to add:</h3>
                    <ul className="text-sm text-blue-800 space-y-1">
                        {doctorsToSeed.map((doc, i) => (
                            <li key={i}>• {doc.name} - {doc.speciality}</li>
                        ))}
                    </ul>
                </div>

                <button
                    onClick={seedDoctors}
                    disabled={loading}
                    className="w-full bg-blue-600 text-white py-3 rounded-lg font-bold hover:bg-blue-700 disabled:bg-gray-400 transition"
                >
                    {loading ? 'Seeding...' : 'Seed Doctors to Firestore'}
                </button>

                {message && (
                    <div className={`mt-4 p-3 rounded ${message.includes('❌') ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
                        {message}
                    </div>
                )}

                <div className="mt-6 text-sm text-gray-500">
                    <p><strong>Note:</strong> Images must exist in <code>public/images/doctors/</code></p>
                    <p className="mt-2">After seeding, go to <a href="/" className="text-blue-600 underline">homepage</a> to see the doctors!</p>
                </div>
            </div>
        </div>
    );
};
